import { queryParams } from './queryParams/queryParams';

export const SKIN_EVO = 'evo';

export const isEvoWrapped = () => queryParams.params?.skin === SKIN_EVO;
